export function formatChartDecimal(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) {
    return "0";
  }
  const s = n.toFixed(2);
  return s.replace(/\.?0+$/, "") || "0";
}
